import axios from "axios";
import { VMAPI_BASE_URL } from "../../Constants";
const api = axios.create({
    baseURL: VMAPI_BASE_URL,
});
export default api;
